import React, {useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { errorFormatter } from '../utils/errorFunctions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { processStatusConstants } from '../utils/fileSizeFunctions'
//import { dateFormatter } from '../utils/dateFunctions'


const reload = () => window.location.reload()
//the mutatiojns look diff than what you are used to looking at
// you created a FileScan.graphql file

const GET_SCAN_QUERY = gql`
  mutation rescanFile($input: RescanFileInput!) {
    rescanFile(input: $input) {
      rescanFile
    }
  }
`

export default function ScanFileModal(props) {

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [showClose, setShowClose] = useState(false)

  const handleClose = () => {
    props.onHide()
    reload()
  }

  const [ scanfile ] = useMutation(
    GET_SCAN_QUERY,
    {
      variables: {
        input: {
          itemId: props.itemId,
          fileName: props.row.name,
          key: props.row.key
        }
      },
      onCompleted: ( { rescanFile}) => {
        if(rescanFile.percent === 100){
          // props.onHide()
          if(rescanFile.error){
            errorFormatter(rescanFile.error)
            console.log('got an error!' + rescanFile.error)
          }
        }
        setIsLoading(false)
        setIsComplete(true)
      }
    },
  )

  return (
    <>
      <Modal {...props} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Scan File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={e => {
              e.preventDefault()
              setIsLoading(true)
              scanfile()
              setShowClose(true)
            }}
          >
            <h3>You are about to rescan and reprocess a file: {props.row.name}</h3>
            {/* {renderProgressBar()} */}
            <Modal.Footer>
              <Button variant='secondary' onClick={handleClose}>{!showClose?'Cancel':'Close'}</Button>
              {isComplete?'':<Button variant="primary" type="submit">{isLoading?<span><FontAwesomeIcon icon={faSpinner} pulse/></span>:''}&nbsp;{'Rescan File'}</Button>}
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}


ScanFileModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string
  }),
  onHide: PropTypes.func,
  itemId: PropTypes.string,
}
